import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { WasteGeneratedInOperations } from "../../../../api";

export const wasteGeneratedInOperationsKeys = {
  items: () => ["wasteGeneratedInOperationsItems"]
};

export function useGetWasteGeneratedInOperationsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...wasteGeneratedInOperationsKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(WasteGeneratedInOperations.getWasteGeneratedInOperationsItems, params), config);
}

export function useAddWasteGeneratedInOperationsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(WasteGeneratedInOperations.addWasteGeneratedInOperationsItems, { questionnaireId, data }), config);
}

export function useUpdateWasteGeneratedInOperationsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(WasteGeneratedInOperations.updateWasteGeneratedInOperationsItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteWasteGeneratedInOperationsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(WasteGeneratedInOperations.deleteWasteGeneratedInOperationsItem, { questionnaireId, recordId }), config);
}

export function useImportWasteGeneratedInOperationsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(WasteGeneratedInOperations.importWasteGeneratedInOperationsItems, { questionnaireId, data }), config);
}

export function useDownloadWasteGeneratedInOperationsTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) => callApi(WasteGeneratedInOperations.getTemplate), config);
}